import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { FormUpdateLoadingService } from 'src/app/services/app/form-update-loading.service';

const SKIP_URL_FRAGMENTS = [
  'exception-log',
  'authenticate',
  'blog-login',
  'portal-login',
  'company-login',
  'select-company',
  'financial-year',
  'searchparties',
  'send-otp',
  'verify-otp',
  'validate-otp',
  'otp-and-email',
  'password-from',
  'subscriber-data',
  'subscriber-details',
  'companyaccess',
  'activity-log',
  'generate-ref-no',
  'payment-data-for-subscription',
  '/report/',
  'reports/',
  '/api/status',
  '/api/start',
  '/api/logout',
  'pdf-invoice',
  'contact-details',
  'email-record',
  'send-sms',
  'send-message',
  'send-media',
  'all-guests',
  'all-companies',
  'states-for-new-company',
  'salary-components',
  'leave-types',
  'leave-type',
  'branch/branch',
  'employee-status/employee-status',
  'employee-type/employee-type',
  'hiring-source/hiring-source',
  'stream/stream',
  'check-tax',
  '/fy',
  '/units',
  '/uqc',
  'all-payments',
  'all-receipts',
  'all-journals',
  'all-contras',
  'all-debit-notes',
  'all-credit-notes',
  'all-stock-transfers',
  'all-unassembles',
  'all-productions',
  'employees',
  'partiesaddresses',
  'getall',
  'search',
];

@Injectable()
export class FormUpdateLoadingInterceptor implements HttpInterceptor {
  constructor(private readonly formUpdateLoadingService: FormUpdateLoadingService) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (!this.shouldTrackRequest(request)) {
      return next.handle(request);
    }

    this.formUpdateLoadingService.show();
    return next.handle(request).pipe(
      finalize(() => this.formUpdateLoadingService.hide()),
    );
  }

  private shouldTrackRequest(request: HttpRequest<unknown>): boolean {
    if (!this.formUpdateLoadingService.isUpdateContextActive()) {
      return false;
    }

    return this.isRecordFetchRequest(request);
  }

  private isRecordFetchRequest(request: HttpRequest<unknown>): boolean {
    const url = request.url.toLowerCase();
    const method = request.method.toUpperCase();

    if (SKIP_URL_FRAGMENTS.some((fragment) => url.includes(fragment))) {
      return false;
    }

    if (url.includes('-by-id') || url.includes('byid')) {
      return method === 'GET' || method === 'POST';
    }

    if (method === 'GET' && /\/\d+(?:\/)?(?:\?|$)/.test(url)) {
      return true;
    }

    return false;
  }
}
